/* eslint-disable react/prop-types */
import React from 'react';
import { Button, List, Modal, Input } from 'antd';
import { EditFilled, ExportOutlined } from '@ant-design/icons';
// import TestItems from './components/SubForms/TestItems';
import T from 'i18n-react';
import { ReactComponent as DeleteIcon } from 'assets/icons/New/FilterBar/Delete.svg';
import classes from './DocumentItem.module.scss';
import { NS } from '../../constants';

export const DocumentItem = ({ item, onRemove, onRename, deletable, renamable }) => {
  const [modal, contextHolder] = Modal.useModal();
  const [fileName, setFileName] = React.useState(item.name);
  const [openEditName, setOpenEditName] = React.useState(false);

  const confirmDelete = () => {
    modal.confirm({
      title: T.translate(`${NS}.areYouSureWantToDelete`),
      content: T.translate(`${NS}.dataWillNotSaved`),
      okText: T.translate(`${NS}.delete`),
      cancelText: T.translate(`${NS}.cancel`),
      onOk: onRemove,
      cancelButtonProps: { hidden: true },
    });
  };

  const actions = React.useMemo(() => {
    const actions = [];
    if (renamable) {
      actions.push(
        <Button
          hidden={!renamable}
          type="link"
          icon={<EditFilled />}
          onClick={() => {
            setOpenEditName(true);
          }}
        />
      );
    }
    if (deletable) {
      actions.push(
        <Button
          hidden={!deletable}
          type="link"
          danger
          icon={<DeleteIcon className={classes.deleteBtn} />}
          onClick={confirmDelete}
        />
      );
    }
    if (!renamable) {
      actions.push(
        <Button
          hidden={renamable}
          type="text"
          icon={<ExportOutlined />}
          onClick={() => {
            window.open(item.url || item.previewUrl, '_blank');
          }}
        />
      );
    }
    return actions;
  }, [deletable, renamable]);

  return (
    <List.Item className={classes.documentItem} actions={actions} split={false}>
      <List.Item.Meta title={item.name} />
      {contextHolder}
      <Modal
        wrapClassName={classes.overlapModal}
        title={T.translate(`${NS}.renameFile`)}
        open={openEditName}
        cancelButtonProps={{ hidden: true }}
        okText={T.translate('general.confirm')}
        onOk={() => {
          onRename(fileName);
          setOpenEditName(false);
        }}
        onCancel={() => {
          setFileName(item.name);
          setOpenEditName(false);
        }}>
        <Input
          value={fileName}
          onChange={(e) => {
            setFileName(e.target.value);
          }}
        />
      </Modal>
    </List.Item>
  );
};
